import React, { useEffect, useState } from "react";
import "./index.css";

import ContentBox from "../ContentBox";

const DISCORD_GUILD_ID = "1353102009250742282"; // The Discord Server ID.
const DISCORD_INVITE_CODE = "bhe37p4qxU"; // Make sure the invite is set to never expire!

const Stats = () => {
  const [currentlyOnline, setCurrentlyOnline] = useState(0);
  const [totalMembers, setTotalMembers] = useState(0);

  const startDate = new Date("2025-03-22");
  const currentDate = new Date();
  const monthsSinceClanFounded =
    (currentDate.getFullYear() - startDate.getFullYear()) * 12 +
    (currentDate.getMonth() - startDate.getMonth());

  // Calculate months/years in service since March 22nd, 2025
  const calculateServiceTime = () => {
    if (monthsSinceClanFounded >= 12) {
      const years = Math.floor(monthsSinceClanFounded / 12);
      return `${years}+`;
    } else {
      return `${monthsSinceClanFounded}+`;
    }
  };

  // Get total members and online members from Discords' API.
  useEffect(() => {
    async function fetchData() {
      const widgetRes = await fetch(
        `https://discord.com/api/guilds/${DISCORD_GUILD_ID}/widget.json`
      );
      const widgetData = await widgetRes.json();
      setCurrentlyOnline(widgetData.presence_count ?? 0);

      const inviteRes = await fetch(
        `https://discord.com/api/v10/invites/${DISCORD_INVITE_CODE}?with_counts=true`
      );
      const inviteData = await inviteRes.json();
      setTotalMembers(inviteData.approximate_member_count ?? 0);
    }

    fetchData();
  }, []);

  /*
  You may change the labels if you want to.
  Don't forget that the Nationalities stat is the only one not dynamic and requires manual updating.
  */
  return (
    <ContentBox header="Stats">
      <div className="stats-container">
        <div className="stat">
          <div className="stat-count">{totalMembers}</div>
          <div className="stat-label">Total members</div>
        </div>
        <div className="stat">
          <div className="stat-count">{currentlyOnline}</div>
          <div className="stat-label">Currently online</div>
        </div>
        <div className="stat">
          <div className="stat-count" /* Update me!*/>55+</div>
          <div className="stat-label">Nationalities</div>
        </div>
        <div className="stat">
          <div className="stat-count">{calculateServiceTime()}</div>
          <div className="stat-label">
            {monthsSinceClanFounded >= 12
              ? "Years in service"
              : "Months in service"}
          </div>
        </div>
      </div>
    </ContentBox>
  );
};

export default Stats;
